import React, { useState, useEffect } from 'react';
import './UndoToast.css';

function UndoToast({ message, duration = 5000, onUndo, onExpire }) {
  const [remaining, setRemaining] = useState(duration);

  useEffect(() => {
    const interval = setInterval(() => {
      setRemaining(prev => {
        if (prev <= 100) {
          clearInterval(interval);
          onExpire();
          return 0;
        }
        return prev - 100;
      });
    }, 100);

    return () => clearInterval(interval);
  }, [duration, onExpire]);

  const progress = (remaining / duration) * 100;

  return (
    <div className="undo-toast">
      <span className="undo-message">{message}</span>
      <button className="undo-btn" onClick={onUndo}>Undo</button>
      <div className="undo-progress" style={{ width: `${progress}%` }} />
    </div>
  );
}

function ToastContainer({ toasts, onUndo, onExpire }) {
  return (
    <div className="toast-container">
      {toasts.map(toast => (
        <UndoToast
          key={toast.id}
          message={toast.message}
          duration={toast.duration || 5000}
          onUndo={() => onUndo(toast.id)}
          onExpire={() => onExpire(toast.id)}
        />
      ))}
    </div>
  );
}

export { UndoToast, ToastContainer };
